import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/brandemi.css";
import "./assets/css/sales_reports.css";
import "./assets/css/responsive.css";
import "./assets/css/pe-icon-7-stroke.css";

import AdminLayout from "layouts/Admin.jsx";
import AuthPage from "views/AuthPage";
import ActivateAccount from "views/ActivateAccount";
import ForgetPassword from "./views/ForgetPassword";
import LoungeProject from "./tableau/LoungeProject";
import LoungeWorkbook from "./tableau/LoungeWorkbook";
import LoungeView from "./tableau/LoungeView";
import LoungeReport from "./tableau/LoungeReport";
import LoungeReport1 from "./tableau/LoungeReport1";
import LoungeReport2 from "./tableau/LoungeReport2";
import TableauEmbed1 from "tableau/TableauEmbed1.jsx";
import LoungeReport20 from "tableau/LoungeReport20.jsx";

// redux implementation for mobile
import {createStore} from "redux";
import {Provider} from "react-redux";
import reducer from "./reducers/reducer";
import ReactGA from "react-ga";

const store = createStore(reducer);
ReactGA.initialize("G-QTBXPZSDZV");

const trackPageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

ReactDOM.render(
 <Provider store={store}>
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={AuthPage} />
      <Route exact path="/activate-account" component={ActivateAccount} />
      <Route path="/admin/forgot-password" component={ForgetPassword} />
      <Route path="/admin/lounge-dashboard/:id" component={LoungeReport} />
      <Route path="/admin/lounge-report/:id" component={LoungeReport1} />
      <Route path="/admin/lounge-reports/:id" component={LoungeReport20} />
      <Route path="/admin/lounge-report2/:id" component={LoungeReport2} />
      <Route path="/admin/lounge-project" component={LoungeProject} />
      <Route path="/admin/lounge-workbook/:id" component={LoungeWorkbook} />
      <Route path="/admin/lounge-view/:id" component={LoungeView} />
      <Route path="/admin/tableau-embed1" component={TableauEmbed1}/>
      <Route
          path="/admin"
          render={(props) => {
            trackPageView(); // Track page view
            return <AdminLayout {...props} />;
          }}
        />

    </Switch>
  </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
